//#region Libraries
import styled from "styled-components";
//#endregion

export const Label = styled.label`
    font-size: 14px;
    font-weight: bold;
    color: var(--dark-4);
`;